export const NO_EPG_DATA = 'No Program Data'

export enum CatchupMode {
  Hourly = 'HOURLY',
  Epg = 'EPG',
}
